/*
 * ELTANE — referral code capture
 *
 * Two separate things land on the page after a friend clicks a referral
 * link (see sections/eltane-referral.liquid for how the link is built):
 *
 *   ?discount={shared code}   appended by Shopify's /discount/{code} route
 *                             itself once it applies the discount — this is
 *                             the ONE shared code everyone uses.
 *   ?ref={customer.id}        the referrer's id, routed through Shopify's
 *                             `redirect` param so it survives the hop
 *                             (Shopify only guarantees ?discount= gets
 *                             appended, not arbitrary extra params).
 *
 * This runs on every page. It stashes the discount code in localStorage so
 * later pages (the cart suggestion banner) can read it even after the
 * visitor browses around or logs in — see getStoredCode(). It also posts
 * `ref` to the cart as the `referred_by` attribute, once per distinct ref
 * value, so it rides along to the Order object for the order-paid Flow to
 * read directly (no metafield-by-value lookup needed on that side).
 */
(function () {
  'use strict';

  var CODE_STORAGE_KEY = 'eltane_referral_code';
  var REF_SENT_KEY = 'eltane_referral_ref_sent';
  var STORAGE_DAYS = 30;

  function getUrlParams() {
    try {
      return new URLSearchParams(window.location.search);
    } catch (e) {
      return null;
    }
  }

  function storeCode(code) {
    try {
      localStorage.setItem(
        CODE_STORAGE_KEY,
        JSON.stringify({ code: code, expires: Date.now() + STORAGE_DAYS * 24 * 60 * 60 * 1000 })
      );
    } catch (e) {}
  }

  function getStoredCode() {
    try {
      var raw = localStorage.getItem(CODE_STORAGE_KEY);
      if (!raw) return null;
      var payload = JSON.parse(raw);
      if (!payload || !payload.code || Date.now() > payload.expires) {
        localStorage.removeItem(CODE_STORAGE_KEY);
        return null;
      }
      return payload.code;
    } catch (e) {
      return null;
    }
  }

  function attachReferrerToCart(ref) {
    var alreadySent = null;
    try {
      alreadySent = localStorage.getItem(REF_SENT_KEY);
    } catch (e) {}
    if (alreadySent === ref) return;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { referred_by: ref } }),
    })
      .then(function (response) {
        if (!response.ok) return;
        try {
          localStorage.setItem(REF_SENT_KEY, ref);
        } catch (e) {}
      })
      .catch(function () {});
  }

  var params = getUrlParams();
  if (params) {
    var urlCode = params.get('discount');
    if (urlCode) storeCode(urlCode);

    var ref = params.get('ref');
    if (ref) attachReferrerToCart(ref);
  }

  window.EltaneReferral = {
    getStoredCode: getStoredCode,
  };
})();
